import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges
} from '@angular/core';
import { NgIf } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';

import { LanguageService } from '../../../services/language.service';
import { ServiceEl } from '../../../model/serviceEl';

@Component({
  selector: 'app-modal-terms',
  standalone: true,
  imports: [NgIf, A11yModule],
  templateUrl: './modal-terms.component.html',
  styleUrl: './modal-terms.component.scss'
})
export class ModalTermsComponent implements OnChanges, OnDestroy {
  @Input() isOpen = false;
  @Input() service: ServiceEl | null = null;

  @Output() closed = new EventEmitter<void>();
  @Output() accepted = new EventEmitter<void>();

  constructor(
    public languageService: LanguageService
  ) {}

  get title(): string {
    const serviceTitle = String(
      this.service?.title ?? ''
    ).trim();

    if (
      this.languageService.currentLanguage === 'ru'
    ) {
      return serviceTitle
        ? `Условия и положения ${serviceTitle}`
        : 'Условия и положения';
    }

    return serviceTitle
      ? `Terms & Conditions of ${serviceTitle}`
      : 'Terms & Conditions';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['isOpen']) {
      return;
    }

    if (this.isOpen) {
      document.body.style.overflow = 'hidden';
      document.body.classList.add(
        'terms-modal-open'
      );
    } else {
      this.restorePageScroll();
    }
  }

  accept(): void {
    this.accepted.emit();
  }

  close(): void {
    this.closed.emit();
  }

  onBackdropClick(): void {
    /*
     * На мобильной версии нижняя модалка
     * закрывается только кнопкой Okay.
     * На десктопе сохраняем старое закрытие
     * по нажатию на фон.
     */
    if (window.innerWidth > 768) {
      this.close();
    }
  }

  ngOnDestroy(): void {
    this.restorePageScroll();
  }

  private restorePageScroll(): void {
    document.body.classList.remove(
      'terms-modal-open'
    );
    document.body.style.overflow = '';
  }
}
